import GeoCodeManager from './geo-code-4';

/**
 * Angular adapter factory for GeoCode4
 */
angular.module('checkout').service(
    'geoCode4Factory',
    [
        '$window',
        'rcmLoading',
        '$timeout',
        function ($window,
                  rcmLoading,
                  $timeout) {
            this.createInstance = function (onStateChangeListener) {
                return new GeoCodeManager(
                    function (geoCodeState) {
                        rcmLoading.setLoading('addressPageGeoCode', geoCodeState.loading ? 0 : 1);
                        /**
                         * Wrapping in $timeout ensures that an angular apply runs which is needed because geoCode4
                         * for does not use $http
                         *
                         * More info:
                         * http://stackoverflow.com/questions/31697409/angularjs-force-digest-after-external-service-request
                         */
                        $timeout(function () {
                            onStateChangeListener(geoCodeState);
                        });
                    },
                    $window.XMLHttpRequest
                );
            };
        },
    ]
);
